import React from "react";
import { Stack, Typography, styled, IconButton } from "@mui/material";
const Card = styled(Stack)(({ theme }: any) => ({
  width: "100%",
  // height: "285px",
  background: theme.palette.common.white,
  border: `2px solid ${theme.palette.common.borderGrey}`,
  "& .shadow-button": {
    color: theme.palette.common.black,
    background: theme.palette.common.white,
    borderRadius: "15px",
    boxShadow: `0px 0.866667px 3.46667px rgba(0, 0, 0, 0.25)`,
  },
}));

export interface VirtualEventCardInterface {
  image: string;
  date: string;
  title: string;
  category: string;
  bookmarked?: boolean;
  setBookmarked: () => void;
}
const VirtualEventCard = ({
  image,
  title,
  date,
  category,
  bookmarked = false,
  setBookmarked,
}: VirtualEventCardInterface) => {
  return (
    <Card p={2} spacing={2}>
      <img
        src={image}
        alt={title}
        height="169px"
        style={{ objectFit: "cover" }}
      />
      <Stack spacing={1.5}>
        <Typography
          // color={(theme: any) => theme.palette.common.grey}
          color="#12121259"
          variant="body1"
          fontSize={12}
          fontWeight={600}
        >
          {date}
        </Typography>
        <Typography color="primary" variant="h4">
          {title}
        </Typography>
      </Stack>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography
          color={(theme: any) => theme.palette.common.darkGrey}
          variant="h5"
          fontWeight={400}
        >
          {category}
        </Typography>
        <IconButton
          color="secondary"
          className="shadow-button"
          onClick={setBookmarked}
        >
          {bookmarked ? (
            <i className="fas fa-bookmark" />
          ) : (
            <i className="far fa-bookmark" />
          )}
        </IconButton>
      </Stack>
    </Card>
  );
};
export default VirtualEventCard;
